import type { FC } from "react";
import { ActivityIndicator, View } from "react-native";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import "../../../theme";

const SearchLoading: FC = () => {
  const { theme } = useUnistyles();
  return (
    <View style={styles.loadingContainer}>
      <ActivityIndicator size="small" color={theme.colors.interactive.buttons.default_background} />
    </View>
  );
};

SearchLoading.displayName = "SearchLoading";

export { SearchLoading };

const styles = StyleSheet.create((theme) => ({
  loadingContainer: {
    paddingVertical: theme.spacing["5xl"],
    alignItems: "center",
    justifyContent: "center",
  },
}));
